<template>
    <v-flex xs12 sm12 d-block class="card-dados">
        <h3 class="card-dados__titulo mb-0">Prazo Encerrado</h3>

        <div class="prazo-encerrado">
            <i class="far fa-clock icone" aria-hidden="true"/>
            <p class="texto">
                O prazo de envio da proposta está encerrado,
                aguarde você será redirecionado em breve,
                ou <a href="javascript:void(0)" @click="irParaResultado">clique aqui</a>.
            </p>
        </div>
    </v-flex>
</template>

<script>
export default {
    name: 'MensagemEncerramento',
    data() {
        return {
            timeout: null,
            timerHandle: null
        }
    },
    mounted() {
        this.redirecionarPagina()
    },
    methods: {
        redirecionarPagina() {
            this.timerHandle = setTimeout(() => {
                this.irParaResultado()
            }, 5000)
            this.timeout = 5
        },
        irParaResultado() {
            const params = (this.$route && this.$route.params) ||
                (this.$router && this.$router.history && this.$router.history.current && this.$router.history.current.params) || {}

            this.$router.push({
                name: 'ResultadoFinalDoFornecedor',
                params: {
                    id: params.id,
                    propostaId: params.propostaId
                }
            })
        }
    },
    destroyed() {
        clearTimeout(this.timerHandle)
    }
}
</script>

<style scoped lang="stylus">
    .prazo-encerrado
        padding 50px
        text-align center
        color #777

        .icone
            font-size 32px
            display block
            margin-bottom 10px

        .texto
            width 40%
            margin 0 auto

    @media (max-width 900px)
        .prazo-encerrado .texto
            width 70%

    @media (max-width 720px)
        .prazo-encerrado .texto
            width 100%
</style>
